interface TotpData {
    token?: string,
    request_id?: string,
    phone?: string,
    message?: string,
}

class ResetTotpService {
    private _resetTotpData: TotpData = {};

    get resetTotpData() {
        return this._resetTotpData;
    }

    set resetTotpData(value) {
        this._resetTotpData = value;
    }
}

export default new ResetTotpService();
